export default "__VITE_ASSET__ad5ebe78__"